import { useEffect, useState } from "react";
import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import { JobRoleDetailService } from "../../../../services/JobRoleDetailService";
import JobRoleDetails from "../../../../components/JobRoleDetailsTree/JobRoleDetails";
import TechAreaHelper from "./TechAreaHelper";
import { TechRoleService } from "../../../../services/TechRoleService";

export default function TechArea({ searchObject, onChange, t }) {
  const [techAreaList, setTechAreaList] = useState([]);
  const [techRoleList, setTechRoleList] = useState([]);

  useEffect(() => {
    getTechAreas();
  }, []);

  function getTechAreas() {
    JobRoleDetailService.getAllTechAreas().then((data) => {
      setTechAreaList(data);
    });
  }
  function getTechRoles(techAreaId) {
    JobRoleDetailService.getAllTechRoles(techAreaId).then((data) => {
      setTechRoleList(data);
    });
  }

  useEffect(() => {
    if (searchObject.techAreaId) {
      getTechRoles(searchObject.techAreaId);
    } else {
      TechRoleService.getAllTechRoles().then((data) => setTechRoleList(data));
    }
  }, [searchObject.techAreaId]);

  return (
    <JobRoleDetails
      searchObject={searchObject}
      onChange={onChange}
      techAreas={techAreaList}
      techRoles={techRoleList}
    >
      <TechAreaHelper
        searchObject={searchObject}
        onChange={onChange}
        techAreaList={techAreaList}
        techRoleList={techRoleList}
      />
    </JobRoleDetails>
  );
}
